/* eslint-disable eqeqeq */
import style from "./CsvImport.module.css";
import gStyle from "../../css/GeneralStyle.module.css";
import React, { useState, useEffect } from "react";
import jwtDefaultConfig from "../../auth/jwt/jwtDefaultConfig";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ClipLoader from "react-spinners/ClipLoader";

import CsvImportComponent from "../../components/common/CsvImportDataCheckInput.tsx";

const ShipperImport = () => {
  const [importErrorData, setImportErrorData] = useState([]);
  const [loadFlag, setLoadFlag] = useState(false);

  let shipperCsvHeader = [
    "ｺｰﾄﾞ",
    "荷主略称",
    "ﾌﾘｶﾞﾅ",
    "郵便番号",
    "電話番号",
    "FAX番号",
    "分類1",
    "重複入庫区分",
    "０詰め（商品）",
    "荷送人設定",
    "荷主名",
    "敬称",
    "住所１",
    "分類2",
    "在庫無区分",
    "０詰め（ﾛｯﾄ）",
    "荷主印字区分",
    "ﾒｰﾙｱﾄﾞﾚｽ",
    "住所２",
    "分類3",
  ];

  useEffect(() => {
    if (importErrorData[0] == "success" && loadFlag == false) {
      toast.success("インポート致しました。", { autoClose: 3000 });
      setImportErrorData([])
    }
    csLoading(loadFlag);
  }, [loadFlag, importErrorData]);

  const csLoading = (flag) => {
    if (flag) {
      document.getElementById("csLoader").style.display = "flex";
    } else {
      document.getElementById("csLoader").style.display = "none";
    }
  };

  return (
    <div className={gStyle.display}>
      <div className={gStyle.loader_container} id="csLoader">
        <ClipLoader color={"#fff"} size={60} />
      </div>
      <ToastContainer />
      <div className={gStyle.border}>
        <p className={gStyle.text}>荷主CSVインポート</p>
      </div>
      <div className={gStyle.filed}>
        <div className={style.cs_card}>
          <CsvImportComponent
            url={jwtDefaultConfig.importShipperCsv}
            setErrorData={setImportErrorData}
            setLoadFlag={setLoadFlag}
            csvHeader={shipperCsvHeader}
          />
          <div className={style.error_tag}>
            {importErrorData?.map((value, index) => (
              value != 'success' &&
              <p className={style.error_content} key={index}>{value}</p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShipperImport;
